import React from 'react'
import Link from 'next/link'
import {
  AddCircleBroken,
  Gift,
  RoundAltArrowRightBroken,
  SaleSquare,
  UserId,
} from 'solar-icons'

import { ShortcutButton } from '@/components/ui'

export const ShortcutButtons = () => {
  const data = React.useMemo(
    () => [
      {
        label: 'Register Loyalty Customer',
        path: '/loyalty/register',
        icon: UserId,
      },
      {
        label: 'Issue Gift Card',
        value: '/gift-card/issue',
        icon: Gift,
      },
      {
        label: 'Redeem a Discount',
        value: '/discount/redeem',
        icon: SaleSquare,
      },
    ],
    [],
  )

  return (
    <div className="flex w-full flex-col gap-2">
      {data?.map(({ label, path, icon }, index) => {
        return (
          <ShortcutButton
            key={index}
            icon={icon}
            className="w-full"
            size="lg"
            asChild
            tabIndex={-1}
          >
            <Link
              href={path || ''}
              className="flex w-full items-center justify-between"
              tabIndex={-1}
            >
              {label}
              <RoundAltArrowRightBroken className="size-6" strokeWidth={1.2} />
            </Link>
          </ShortcutButton>
        )
      })}

      <ShortcutButton
        className="w-full justify-between"
        size="lg"
        variant="subtle"
        tabIndex={-1}
      >
        <div className="flex w-full items-center justify-between">
          <span>Add a new shortcut</span>
          <AddCircleBroken className="size-6" strokeWidth={1.2} />
        </div>
      </ShortcutButton>
    </div>
  )
}
